import Vue from 'vue';
import VNode from 'vue';
import Component from 'vue-class-component';
import App from './App.vue';
import IdleTimer from '@/lib/util/IdleTimer';
import Lockr from 'lockr';
import { $nav } from '@/lib/KioskNavigation';
import { version } from '@/version';
import { IS_STAGING } from '@/lib/util/ProjectConfig';

Vue.config.productionTip = false;
const FIVE_MINUTES: number = 5 * 60 * 1000;

@Component
export default class RootVue extends Vue {

  // non-reactive properties
  private navigationStack: string[] = [];
  //private isVideoMutedGlobally: boolean = true;

  // lifecycle
  created() {
    const isDisableIdleTimer = Lockr.get('kb_isDisableIdleTimer', false);
    if ( !isDisableIdleTimer ) {
      this.installIdleTimer();
    }
    else {
      console.log('do not install an idle timer');
    }

    if ( this.$route.path !== '/' ) {
      this.navigationStack.push('/');
    }
  }

  // computed
  get appVersion(): string {
    return (IS_STAGING ? 'Σ' : 'v') + version;
  }

  // methods
  installIdleTimer() {
    const minutes = FIVE_MINUTES / 60000;
    console.log(`install ${minutes} minute idle timer`);
    new IdleTimer(FIVE_MINUTES, () => {
      console.log("idle timeout");
      if ( '/' !== this.$root.$route.path ) {
        console.log("  `--> re-routing to '/'");
        $nav.home(this);
      }
      else {
        // broadcast this fact -- the homepage may need to restart its video
        this.$root.$emit('idle-on-homepage');
      }
    }).reset();
  }

  render(createElement: typeof Vue.prototype.$createElement): VNode {
    return createElement(App);
  }

}
